/** @jsx jsx */
import { css, jsx } from '@emotion/react'
import React from 'react'
import {
  StartGuide,
  StartGuideItem,
} from '../admin/facility_detail_form/StartGuide'
import { CardSection, Heading } from './CardSection'
import {
  FlowContainer,
  FlowHeading,
  Image,
  Label,
  LastItemWrapper,
  Link,
  Note,
} from './Flow'

export type StartFlowBlock = {
  title: string
  items?: StartGuideItem[]
}

export type StartFlowProps = {
  blocks: StartGuide
}

export const StartFlow = ({ blocks }: StartFlowProps) => {
  const containerOverrideStyle = css`
    &::before {
      top: 10px;
    }
  `
  const linkStyle = css`
    margin-top: 10px;
  `
  const imageStyle = css`
    margin-top: 20px;
  `
  return (
    <CardSection>
      <Heading as="h3">この施設への登録の流れ</Heading>
      <FlowContainer css={containerOverrideStyle}>
        {blocks &&
          blocks.map((block, i) =>
            i !== blocks.length - 1 ? (
              <React.Fragment key={block.id}>
                <FlowHeading
                  style={{
                    marginTop: i === 0 ? 0 : '',
                  }}
                >
                  <Label>{block.title}</Label>
                </FlowHeading>
                {block.items &&
                  block.items.map((item) => (
                    <React.Fragment key={item.content}>
                      {item.type === 'paragraph' && <Note>{item.content}</Note>}
                      {item.type === 'link' && (
                        <Link
                          href={item.href}
                          // 現状、常に別タブで開くで良いとのことで、targetBlank フィールドを無視する
                          target={'_blank'}
                          rel={'noopener noreferrer'}
                          beforeIcon="vector_right"
                          css={linkStyle}
                        >
                          {item.content}
                        </Link>
                      )}
                      {item.type === 'telephone' && (
                        <Link
                          key={item.content}
                          href={'tel:' + item.content}
                          beforeIcon="phone"
                          css={linkStyle}
                        >
                          {item.content}
                        </Link>
                      )}
                      {item.type === 'image' && (
                        <Image
                          key={item.content}
                          src={item.content}
                          css={imageStyle}
                          alt={item.alt}
                        />
                      )}
                    </React.Fragment>
                  ))}
              </React.Fragment>
            ) : (
              <LastItemWrapper key={block.id}>
                <FlowHeading
                  style={{
                    marginTop: i === 0 ? 0 : '',
                  }}
                >
                  <Label>{block.title}</Label>
                </FlowHeading>
                {block.items &&
                  block.items.map((item) => (
                    <React.Fragment key={item.content}>
                      {item.type === 'paragraph' && <Note>{item.content}</Note>}
                      {item.type === 'link' && (
                        <Link
                          href={item.href}
                          // 現状、常に別タブで開くで良いとのことで、targetBlank フィールドを無視する
                          target={'_blank'}
                          rel={'noopener noreferrer'}
                          beforeIcon="vector_right"
                          css={linkStyle}
                        >
                          {item.content}
                        </Link>
                      )}
                      {item.type === 'telephone' && (
                        <Link
                          key={item.content}
                          href={'tel:' + item.content}
                          beforeIcon="phone"
                          css={linkStyle}
                        >
                          {item.content}
                        </Link>
                      )}
                      {item.type === 'image' && (
                        <Image
                          key={item.content}
                          src={item.content}
                          css={imageStyle}
                        />
                      )}
                    </React.Fragment>
                  ))}
              </LastItemWrapper>
            ),
          )}
      </FlowContainer>
    </CardSection>
  )
}
